export default "__VITE_ASSET__JbB0g3Gu__"